export default "__VITE_ASSET__jZy2t2k5__"